// Driver's Vehicle Inspection Report (DVIR) checklist items.
// Transcribed from the paper form Alba uses today (app support requests #52 / #59).
// Per James: copy the template as-is, minus the mechanic signature block.

export const vehicleItems = [
  { key: "airCompressor", label: "Air Compressor" },
  { key: "airLines", label: "Air Lines" },
  { key: "battery", label: "Battery" },
  { key: "brakeAccessories", label: "Brake Accessories" },
  { key: "brakes", label: "Brakes" },
  { key: "carburetor", label: "Carburetor" },
  { key: "clutch", label: "Clutch" },
  { key: "defroster", label: "Defroster" },
  { key: "driveLine", label: "Drive Line" },
  { key: "engine", label: "Engine" },
  { key: "fifthWheel", label: "Fifth Wheel" },
  { key: "frontAxle", label: "Front Axle" },
  { key: "fuelTanks", label: "Fuel Tanks" },
  { key: "heater", label: "Heater" },
  { key: "horn", label: "Horn" },
  {
    key: "lights",
    label: "Lights",
    detail: "Head – Stop / Tail – Dash / Turn Indicators",
  },
  { key: "mirrors", label: "Mirrors" },
  { key: "muffler", label: "Muffler" },
  { key: "oilPressure", label: "Oil Pressure" },
  { key: "onBoardRecorder", label: "On-Board Recorder" },
  { key: "radiator", label: "Radiator" },
  { key: "rearEnd", label: "Rear End" },
  { key: "reflectors", label: "Reflectors" },
  {
    key: "safetyEquipment",
    label: "Safety Equipment",
    detail:
      "Fire Extinguisher / Flags – Flares – Fuses / Spare Bulbs & Fuses / Spare Seal Beam",
  },
  { key: "springs", label: "Springs" },
  { key: "starter", label: "Starter" },
  { key: "steering", label: "Steering" },
  { key: "tachograph", label: "Tachograph" },
  { key: "tires", label: "Tires" },
  { key: "transmission", label: "Transmission" },
  { key: "wheels", label: "Wheels" },
  { key: "windows", label: "Windows" },
  { key: "windshieldWipers", label: "Windshield Wipers" },
  { key: "other", label: "Other" },
];

export const trailerItems = [
  { key: "trailerBrakeConnections", label: "Brake Connections" },
  { key: "trailerBrakes", label: "Brakes" },
  { key: "trailerCouplingChains", label: "Coupling Chains" },
  { key: "trailerCouplingKingPin", label: "Coupling (King) Pin" },
  { key: "trailerDoors", label: "Doors" },
  { key: "trailerHitch", label: "Hitch" },
  { key: "trailerLandingGear", label: "Landing Gear" },
  { key: "trailerLights", label: "Lights – All" },
  { key: "trailerRoof", label: "Roof" },
  { key: "trailerSprings", label: "Springs" },
  { key: "trailerTarpaulin", label: "Tarpaulin" },
  { key: "trailerTires", label: "Tires" },
  { key: "trailerWheels", label: "Wheels" },
  { key: "trailerOther", label: "Other" },
];

export default { vehicleItems, trailerItems };
